module.exports = __webpack_public_path__ + "media/images/incentive-f9932803e0fb2ceb4539d81f3fcee7de.png";